import {atom} from 'jotai'

export const firebaseAtom = atom({
  name: '',
  email: '',
  token: '',
})
